export enum widgetFilters {
    customer = 1,
    class = 2,
    svcConst = 3,
    state = 4,
    acctMgr = 5,
    contAdmin = 6,
    svcMgr = 7,
    biller = 8,
    salesPerson = 9,
    dateRange = 10,
    quoteStatus = 11,
    invoiceStatus = 12,
    technicians = 13,
    locations = 14,
    status = 15,
    divisions = 16,
    supplier = 17,
    dispatchNbr = 18,
    quoteNbr = 19,
    invoiceNbr = 20,
    orderNbr = 21,
    inventoryNbr = 22,
    fiscalYear = 23,
    regions = 24,
    invoiceSalesSummaryTypes = 25,
    requestor = 26,
    isSub = 27,
    dispatchStatus = 28,
    buyer = 29,
    orderStatus = 30,
    onCallRegion = 31,
    techCreated = 32,
    disputeAmmount = 33,
    creditMemoStatus = 34,
    creditReasonCode = 35,
    invoiceStatusApproval = 36,
    discreetBiller = 37,
    defaultSubmitter = 38,
    daysAged = 39,
    customerInclusivity = 40,
    purchaser = 41,
    priority = 42,
    projectManager = 43,
    rank = 44
}